import Tools from "../../../base/components/tools";
import AlertModal from "./alertModal";
export default class FormularioEntrada extends React.Component {
  constructor(props) {
    super(props);

    this.pnpService = new ServicioPnp();
    this.tools = new Tools();

    this.state = {
      //Agregar los 5 campos
      form: {
        fullName: { error: "", valid: "", value: "" },
        identificationType: {
          error: "",
          valid: "",
          value: "Seleccione un documento",
          sigla: "",
        },
        identificationNumber: { error: "", valid: "", value: "" },
        phone: { error: "", valid: "", value: "" },
        email: { error: "", valid: "", value: "" },
        confirmEmail: { error: "", valid: "", value: "" },
        isContacted: { error: "", valid: "", value: "" },
        confirmPersonalData: { error: "", valid: "", value: true },
        confirmEmailMessage: { error: "", valid: "", value: true },
        confirmTextMessage: { error: "", valid: "", value: true },
      },
      isSubmitted: false,
      typeDocList: [],
      isDisabled: true,
      formIsValid: false,
      politicaTratamientoDatos: null,
      showModal: false,
      showModalPlanVital: false,
    };

    this.errorMessages = {
      required: "es requerido",
      maxlength: "ha excedido del valor maximo permitido",
      email: "Por favor ingrese una dirección de correo",
      equalTo: "No es igual al correo personal",
      number: "solo permite números",
      isEmailRequired: "es requerida",
      minlength: "debe contener un mínimo de 10 dígitos",
      alphanumeric: "No permite caracteres especiales",
    };

    this.setRulesForm = this.setRulesForm.bind(this);
    this.saludValidaciones = new SaludValidaciones(
      this.state.form,
      this.setRulesForm()
    );
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.getDocType = this.getDocType.bind(this);
    this.setCursorAtBegin = this.setCursorAtBegin.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.removeEmojis = this.removeEmojis.bind(this);
    this.removeNonLetters = this.removeNonLetters.bind(this);
    this.removeLetters = this.removeLetters.bind(this);

    $(window).keyup((e) => {
      var code = e.keyCode ? e.keyCode : e.which;
      if (
        code == 9 &&
        $("#confirmEmail:focus").length &&
        $("#confirmEmail").val() == "@"
      ) {
        const input = document.getElementById("confirmEmail");
        input.setSelectionRange(0, 0);
      }
    });
  }

  componentDidMount() {
    this.pnpService.getList("tiposDocumento", (list) => {
      this.setState({ typeDocList: list }, () => { });
    });
    this.pnpService.getListByTitle(
      "AdministracionTerminosCondiciones",
      (item) => {
        let planComplementario = item.filter(
          (item) => item.Funcionalidad == "TerminosCotizadorPlanComplementario"
        );
        let planVital = item.filter(
          (item) => item.Funcionalidad == "TerminosCotizadorPlanVital"
        );
        this.setState({
          politicaTratamientoDatos: planComplementario[0],
          politicaTratamientoDatosPlanVital: planVital[0],
        });
      },
      "",
      "TerminosCondiciones",
      "Title",
      "Funcionalidad"
    );

    let counter = 0;

    const repeatValidation = () => {
      if (counter < 5) {
        this.validateForm();
        counter++;
        setTimeout(repeatValidation, 2000); // Llama de nuevo después de 4 segundos
      }
    };

    repeatValidation(); // Inicia el proceso


    /* setTimeout(() => {
      this.validateForm();
    }, 4000);

    setTimeout(() => {
      this.validateForm();
    }, 6000);

    setTimeout(() => {
      this.validateForm();
    }, 10000); */
  }



  /* componentDidUpdate(prevProps, prevState) {
    if (
      prevState.form.email.value !== '' &&
      prevState.form.fullName.value !== '' &&
      prevState.form.phone.value !== '' &&
      prevState.form.identificationNumber.value !== ''
    ) {
      this.validateForm();
    }
  } */

  componentWillReceiveProps(props) {
    const showModalPlanVital = props.showModalPlanVital;
    const name = { ...this.state.form };
    name.fullName.value = props.form.name.value;
    const email = { ...this.state.form };
    email.email.value = props.form.email.value;
    const identificationType = { ...this.state.form };
    identificationType.identificationType.value =
      props.form.identificationType.value;
    const identificationTypeSigla = { ...this.state.form };
    identificationType.identificationType.sigla =
      props.form.identificationType.sigla;
    const identificationNumber = { ...this.state.form };
    identificationNumber.identificationNumber.value =
      props.form.identificationNumber.value;
    const phone = { ...this.state.form };
    phone.phone.value = props.form.phone.value;
    this.setState({
      form: name,
      form: email,
      form: identificationType,
      form: identificationTypeSigla,
      form: identificationNumber,
      form: phone,
      showModalPlanVital,
    });
    // this.setState({ form: props.form });
  }

  getDocType(docType) {
    if (docType !== "Seleccionar") {
      const typeDocList = this.state["typeDocList"];
      let typeDoc = typeDocList.find(
        (elem) =>
          elem.CSDocumentoIdentidadText === docType ||
          elem.CSIdDocumentoText === docType
      );
      return typeDoc.CSSiglaText;
    } else {
      return null;
    }
  }

  UrlCatcher() {
    var ultimaPosicion = window.location.pathname.split("/");
    var nivelAnterior = ultimaPosicion.slice(ultimaPosicion.length - 1);
    var text = "";
    nivelAnterior.forEach((item) => {
      text = text + "/" + item;
    });
    return decodeURI(text).slice(1);
  }

  setRulesForm() {
    const email = this.state.form.email.value;
    const rules = {
      fullName: {
        required: true,
        maxlength: 105,
      },
      email: {
        email: true,
      },
      confirmEmail: {
        email: true,
        equalTo: (value) => {
          return (
            value.trim().toLowerCase() ===
            this.state.form.email.value.trim().toLowerCase() &&
            this.state.form.email.value.trim().toLowerCase()
          );
        },
        required: () => {
          return this.state.form.email.value;
        },
      },
      identificationNumber: {
        maxlength: 60,
        required: true,
        alphanumeric: (value) => {
          return (
            /^[ _]*[a-zA-Z0-9  áéíóúÁÉÍÓÚñÑ]*$/.test(value) &&
            value.trim() != ""
          );
        },
      },
      identificationType: {
        required: true,
      },
      phone: {
        required: true,
        maxlength: 10,
        number: true,
        minlength: 10,
      },
    };
    return rules;
  }

  handleInputChange(event) {
    if (event) {
      const target = event.target;
      const value = target.type === "checkbox" ? target.checked : target.value;
      if (target.name === "fullName") {
        let nameValidated = this.removeEmojis(value);
        nameValidated = this.removeNonLetters(value);
        const name = target.name;
        let FormValues = this.state.form;
        FormValues[name].value = nameValidated;
        this.setState(
          {
            form: FormValues,
          },
          () => {
            this.validateForm();
          }
        );
      } else if (
        target.name === "identificationNumber" ||
        target.name === "phone"
      ) {
        let idValidated = this.removeLetters(value);
        const name = target.name;
        let FormValues = this.state.form;
        FormValues[name].value = idValidated;
        this.setState(
          {
            form: FormValues,
          },
          () => {
            this.validateForm();
          }
        );
      } else {
        const name = target.name;
        let FormValues = this.state.form;
        FormValues[name].value = value;
        this.setState(
          {
            form: FormValues,
          },
          () => {
            this.validateForm();
          }
        );
      }
    }
    this.handleBlur(event);
  }

  handleSelect(item) {
    let FormValues = this.state.form;
    FormValues["identificationType"].value = item.CSDocumentoIdentidadText;
    let IdSigla = this.state.form;
    IdSigla["identificationType"].sigla = item.CSSiglaText;
    IdSigla["identificationType"].id = item.CSIdDocumentoText;
    this.setState(
      {
        form: FormValues,
        form: IdSigla,
      },
      () => {
        this.validateForm();
      }
    );
  }

  handleSubmit(event, boolean) {
    event.preventDefault();
    this.validateForm();
    if (!this.state.formIsValid) {
      console.log('formIsValid false');
      this.setState({ showModal: true });
    } else {
      console.log('formIsValid true');
      let userInfoCheck = compTools.obtenerInformacionUsuario();
      dataLayer.push({
        event: "cotizacion_plan",
        user_id: userInfoCheck.Nautcli,
        log_status: "true",
        login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
        affiliation: "Salud",
        bread_crumbs: this.UrlCatcher(),
        step: "Paso 1",
        option: "Cotiza Plan Complementario Especial"
      })
      this.props.updateState(this.state.form, 2);
    }
  }

  handlePlanVital() {
    let userInfoCheck = compTools.obtenerInformacionUsuario();
    dataLayer.push({
      event: "cotizacion_plan",
      user_id: userInfoCheck.Nautcli,
      log_status: "true",
      login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
      affiliation: "Salud",
      bread_crumbs: this.UrlCatcher(),
      step: "Paso 1",
      option: "Cotiza Plan Vital"
    })
    this.setState({ showModalPlanVital: true });
  }

  handleBlur(event, elementId) {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    let element = event.target;
    this.saludValidaciones.validateField(element, currentForm);
    this.setState({ form: currentForm }, () => {
      this.validateForm();
    });
  }

  handleFocus(event) {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    if (!event.target.value) {
      currentForm[event.target.id].value = "@";
      this.setCursorAtBegin();
    }
    this.setState({ form: currentForm });
  }

  setCursorAtBegin() {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    if (currentForm["email"].value == "@") {
      const input = document.getElementById("email");
      input.setSelectionRange(0, 0);
      // this.validateForm()
    } else if (currentForm["confirmEmail"].value == "@") {
      const input = document.getElementById("confirmEmail");
      input.setSelectionRange(0, 0);
    }
    currentForm.confirmEmail.value.toLowerCase() ==
      currentForm.email.value.toLowerCase()
      ? (currentForm.confirmEmail.valid = true)
      : (currentForm.confirmEmail.valid = false);
    this.setState({ form: currentForm });
    this.validateForm();
  }

  removeEmojis(string) {
    const regex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
    return string.replace(regex, "");
  }

  removeNonLetters(string) {
    const regex = /[^a-zA-Z\s]/gi;
    return string.replace(regex, "");
  }

  removeLetters(string) {
    const regex = /\D+/g;
    return string.replace(regex, "");
  }

  validateForm() {
    if (
      /* this.state.form.confirmEmail.value.toLowerCase() ==
      this.state.form.email.value.toLowerCase() && */
      this.state.form.confirmEmailMessage.value === true &&
      this.state.form.confirmPersonalData.value === true &&
      this.state.form.confirmTextMessage.value === true &&
      this.state.form.email.valid === true &&
      this.state.form.email.value !== "@" &&
      this.state.form.email.value !== "" &&
      this.state.form.phone.valid === true &&
      this.state.form.phone.value !== "" &&
      this.state.form.fullName.valid === true &&
      this.state.form.fullName.value !== "" &&
      this.state.form.identificationNumber.valid === true &&
      this.state.form.identificationNumber.value !== "" &&
      this.state.form.identificationType.valid === true &&
      this.state.form.identificationType.value !== "" &&
      this.state.form.identificationType.value !== "Seleccione un docuemnto"
    ) {
      this.setState({ formIsValid: true });
    } else {
      this.setState({ formIsValid: false });
    }
  }

  handleHide(boolean) {
    this.setState({ showModal: boolean, showModalPlanVital: false });
  }

  innerHtml(title) {
    return { __html: title };
  }

  render() {
    let loginURL = "";
    if (Object.keys(this.props.configurations).length) {
      loginURL = this.tools.getLoginURL(this.props.configurations["FBA_CLAIM"]);
    }
    loginURL = '/_layouts/15/Authenticate.aspx?Source=/salud/Paginas/CotizadorMP.aspx'
    return (
      <div className="container-cotizador">
        <Modal
          show={this.state.showModal}
          backdrop="static"
          aria-labelledby="contained-modal-title-sm"
        >
          <Modal.Header style={{ paddingBottom: 0 }}>
            <p id="titulo-modal" style={{ fontSize: 'large', color: '#000' }}>Validar Datos</p>
          </Modal.Header>
          <Modal.Body>
            <div className="body-container">
              <div id="cuerpo-modal" className="col-xs-12 messages" style={{ fontSize: 'initial', color: '#000' }}>
                Hubo un error en el diligenciamiento del formulario, por favor valida que los datos ingresados sean correctos.
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => this.setState({ showModal: false })}
            >
              Aceptar
            </button>
          </Modal.Footer>
        </Modal>

        <div
          className={
            "cotizar-is-authenticated" +
            (this.props.isAuthenticated ? " hidden" : "")
          }
        >
          Si tienes un usuario y contraseña Compensar{" "}
          <a href={loginURL}>Inicia Sesión</a> para una respuesta más detallada
          y para poder iniciar tu compra.
        </div>
        <br></br>
        <div className="row title">
          <div className="col-md-12">
            <h2><strong>Cotiza tu plan</strong></h2>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <p className="normal-text">Ingresa los datos y recibirás el precio aproximado del Plan.</p>
            <br></br>
            <div>
              {/* nombre */}
              <div className={"form-group" +
                (this.state.form.fullName.valid ? "" : " has-error")}>
                <label for="fullName" className="normal-text">Nombre completo*</label>
                <div className="input-group">
                  <span className="input-group-addon"><i className="fa fa-user"></i></span>
                  <input type="text" id="fullName" name="fullName" className="form-control"
                    value={this.state.form.fullName.value}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                  />
                </div>
                <p
                  className={
                    this.state.form.fullName.valid ? "hidden" : "error"
                  }
                >
                  Nombre completo{" "}
                  {this.errorMessages[this.state.form.fullName.error]}
                </p>
              </div>

              {/* tipo id */}
              <div className="row">
                <div className="col-md-6">
                  <div className={"form-group" +
                    ((this.state.form.identificationType.value ===
                      "Seleccionar" &&
                      !this.state.isSubmitted) ||
                      this.state.form.identificationType.value !==
                      "Seleccionar"
                      ? ""
                      : " has-error")}>
                    <label for="identificationType" className="normal-text">Tipo de documento*</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-id-card"></i></span>
                      <select
                        title={this.state.form.identificationType.value}
                        id="identificationType" class="form-control"
                      >
                        {this.state.typeDocList.map((item) => {
                          return (
                            <option
                              key={item.CSIdDocumentoText}
                              eventKey={item.CSDocumentoIdentidadText}
                              className={
                                this.state.form.identificationType.value ===
                                  item.CSDocumentoIdentidadText
                                  ? "active"
                                  : ""
                              }
                              onClick={() => this.handleSelect(item)}
                            >
                              <span>{item.CSDocumentoIdentidadText}</span>
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <p
                      className={
                        (this.state.form.identificationType.value ===
                          "Seleccionar" &&
                          !this.state.isSubmitted) ||
                          this.state.form.identificationType.value !==
                          "Seleccionar"
                          ? "hidden"
                          : "error"
                      }
                    >
                      Tipo de documento es requerido
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={"form-group" +
                    (this.state.form.identificationNumber.valid ? "" : " has-error")}>
                    <label for="identificationNumber" className="normal-text">Número de documento*</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-hashtag"></i></span>
                      <input
                        type="text"
                        id="identificationNumber"
                        name="identificationNumber"
                        className="form-control"
                        maxLength={12}
                        value={this.state.form.identificationNumber.value}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <p
                      className={
                        this.state.form.identificationNumber.valid
                          ? "hidden"
                          : "error"
                      }
                    >
                      Documento de Identidad{" "}
                      {
                        this.errorMessages[
                        this.state.form.identificationNumber.error
                        ]
                      }
                    </p>
                  </div>
                </div>
              </div>

              {/* telefono */}
              <div className="row">
                <div className="col-md-6">
                  <div className={"form-group" +
                    (this.state.form.phone.valid ? "" : " has-error")}>
                    <label for="phone" className="normal-text">Teléfono Móvil*</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-phone"></i></span>
                      <input type="tel" id="phone" name="phone" className="form-control"
                        pattern=".{10,10}"
                        maxLength={10}
                        minLength={10}
                        value={this.state.form.phone.value}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                      />
                    </div>
                    <p
                      className={this.state.form.phone.valid ? "hidden" : "error"}
                    >
                      Teléfono Móvil{" "}
                      {this.errorMessages[this.state.form.phone.error]}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className={"form-group" +
                    (this.state.form.email.valid ? "" : " has-error")}>
                    <label for="email" className="normal-text">Correo electrónico*</label>
                    <div className="input-group">
                      <span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                      <input type="email" id="email" name="email" className="form-control"
                        value={this.state.form.email.value}
                        onPaste={(e) => e.preventDefault()}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                        onClick={this.setCursorAtBegin}
                      />
                    </div>
                    {this.state.form.email.value === "@" ? (
                      <p
                        className={
                          this.state.form.email.valid ? "hidden" : "error"
                        }
                      >
                        {this.props.configurations.MensajeCorreoRequerido}
                      </p>
                    ) : (
                      <p
                        className={
                          this.state.form.email.valid ? "hidden" : "error"
                        }
                      >
                        {this.props.configurations.MensajeCorreoInvalido}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="checkbox">
                <label className="normal-text">
                  <input type="checkbox" className="form-check-input"
                    id="confirmPersonalData"
                    name="confirmPersonalData"
                    checked={this.state.form.confirmPersonalData.value}
                    onChange={this.handleInputChange}
                  />
                  Autorización de <a href="#">tratamiento de los datos personales</a>
                </label>
              </div>

              <div className="checkbox">
                <label className="normal-text">
                  <input type="checkbox" className="form-check-input"
                    id="confirmEmailMessage"
                    name="confirmEmailMessage"
                    checked={this.state.form.confirmEmailMessage.value}
                    onChange={this.handleInputChange}
                  />
                  Acepto recibir información de Compensar en mi correo electrónico
                </label>
              </div>

              <div className="checkbox">
                <label className="normal-text">
                  <input type="checkbox" className="form-check-input"
                    id="confirmTextMessage"
                    name="confirmTextMessage"
                    checked={this.state.form.confirmTextMessage.value}
                    onChange={this.handleInputChange}
                  /> Acepto recibir mensajes de texto en mi teléfono móvil con
                  información de Compensar (Estos mensajes no tienen costo)
                </label>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-secondary"
                  onClick={this.handleSubmit}
                >
                  Cotizar
                </button>
              </div>

              <div className="important-notice">
                <strong>IMPORTANTE:</strong> Los precios son aproximados y pueden variar según validación de los
                datos
                suministrados.
              </div>
            </div>
          </div>

          <div className="col-md-6 benefits-price">
            <div className="panel-group" id="benefitsAccordion">
              {/* Sección de Beneficios */}
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a data-toggle="collapse" data-parent="#benefitsAccordion" href="#collapseBenefits"
                      className="collapsed title-text">
                      Beneficios
                    </a>
                  </h4>
                </div>
                <div id="collapseBenefits" className="panel-collapse collapse">
                  <div className="panel-body benefits-list">
                    <ul className="normal-text">
                      <li>Habitación individual en caso de hospitalización en la red de clínicas
                        preferencial</li>
                      <li>8 Especialidades de acceso directo en las Sedes exclusivas de Compensar</li>
                      <li>Orientación médica telefónica de urgencias las 24 horas</li>
                      <li>Cobertura de maternidad y Cubrimiento al recién nacido</li>
                      <li>Citas al día</li>
                      <li>APP exclusiva para Citas, Pagos y Resultados de Laboratorio</li>
                      <li>Cubrimiento parcial de cuotas moderadoras</li>
                      <li>Beneficios saludables en nuestra comunidad Disfruta tu salud</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/*  <!-- Sección de Condiciones --> */}
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <a data-toggle="collapse" data-parent="#benefitsAccordion" href="#collapseConditions"
                      className="collapsed title-text">
                      Condiciones
                    </a>
                  </h4>
                </div>
                <div id="collapseConditions" className="panel-collapse collapse">
                  <div className="panel-body benefits-list">
                    <ul className="normal-text">
                      <li>Requieres examen de ingreso si eres mayor de 60 años.</li>
                      <li>Debes estar afiliado a una EPS en Régimen Contributivo o pertenecer a un régimen
                        de excepción.</li>
                      <li>Debes completar el formulario de asegurabilidad (declaración de estado de salud)
                        previo a la afiliación.</li>
                      <li>Transcurridos (2) meses de mora se suspenderá el contrato y no será posible
                        acceder a los servicios hasta que los pagos estén al día.</li>
                      <li>A los tres (3) meses de mora, se perderá la continuidad y la antigüedad en el
                        Plan.</li>
                      <li>Debes estar al día en los pagos de tu EPS para acceder a los servicios del Plan.
                      </li>

                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="price-section">
              <div className="price-box">
                <p className="normal-text"><strong>Precio Mensual Desde</strong></p>
                <div className="price">$0</div>
              </div>

              <div className="total-row">
                <div className="row">
                  <div className="col-xs-6">
                    <strong>0 Afiliados</strong>
                    <div className="small">Menores de 60</div>
                  </div>
                  <div className="col-xs-6 text-right">
                    <strong>$0</strong>
                  </div>
                </div>
              </div>

              <div className="total-row">
                <div className="row">
                  <div className="col-xs-6">
                    <strong>0 Afiliados</strong>
                    <div className="small">Mayores de 60</div>
                  </div>
                  <div className="col-xs-6 text-right">
                    <strong>$0</strong>
                  </div>
                </div>
              </div>

              <div className="total-row-last">
                <div className="row">
                  <div className="col-xs-6">
                    <strong>Total año</strong>
                    <div className="small">0 afiliados</div>
                  </div>
                  <div className="col-xs-6 text-right">
                    <strong>$0</strong>
                  </div>
                </div>
              </div>
            </div>

            <div className="btn-options">
              <button className="btn btn-secondary">Cerrar</button>
              <button id="btn-afiliate" className="btn btn-secondary"><span className="glyphicon glyphicon-arrow-right"></span>
                Afiliate</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Modal = ReactBootstrap.Modal;
const DropdownButton = ReactBootstrap.DropdownButton;
const MenuItem = ReactBootstrap.MenuItem;
